//
//
//
//

import * as dd from 'dingtalk-jsapi';
import {ddCorpId} from "../../utils/commons";

export default {
  name: "dd-login",
  methods:{
    getCurrent(){
      this.$get('api/person/current').then((data) => {
        this.$store.dispatch('commitChangeType',data.userType);
        this.$store.dispatch('commitChangeUserId',data.id);
        if(this.$store.state.userType == '1'){
          this.$store.dispatch('commitChangeSupId',null);
        }else{
          this.$get('api/supplier/current-sample').then((res) => {
            this.$store.dispatch('commitChangeSupId',res.id);
          })
        }
      })
    }
  },
  mounted(){
    let _this = this;
    if(!localStorage.getItem('_token')){
      try{
        if(dd.other){
          _this.$router.push('/user/login');
        }else{
          dd.ready(function(){
            dd.runtime.permission.requestAuthCode({
              corpId: ddCorpId,
              onSuccess: function(res) {
                _this.$loadingShow();
                _this.$get('api/dingding/authenticate/' + res.code).then((data) => {
                  _this.$loadingHide();
                  _this.$store.dispatch('commitChangeBrowse','dd');
                  if(data.status === 'success'){
                    localStorage.setItem('_token',"Bearer " + data.msg);
                    this.getCurrent();
                    _this.$router.push('/');
                  }else{
                    _this.$vux.toast.text(data.msg);
                    _this.$router.push('/user/login');
                  }
                }).catch((err) => {
                  _this.$loadingHide();
                  _this.$router.push('/user/login');
                })
              },
              onFail : function(err) {
                _this.$vux.toast.text(err.errorMessage);
                _this.$router.push('/user/login');
              }
            });
          });
        }
      }catch(e){
        _this.$router.push('/user/login');
      }
    }else{
      _this.$router.push('/');
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/user/dd-login.vue